module.exports=require('./ranges.js').flatMap(r=>Array.from(r.keys()))